<kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
  <div class="flex-row flex-wrap">
    <div class="flex-column form__column" *ngIf="item && item.getDisplayName">
      <div class="flex-row form__control">
        <label translate>Name</label>
        <div class="form__input">{{ item.getDisplayName() }}</div>
      </div>
      <div class="flex-row form__control">
        <label translate>Amount</label>
        <div class="form__input">{{ item.quantity }}</div>
      </div>
      <div class="flex-row form__control">
        <label translate>Used</label>
        <div class="form__input">{{ item.quantityAssigned }}</div>
      </div>
      <div class="flex-row form__control">
        <label translate>Validity</label>
        <div class="form__input">
          {{ item.validFromDateTime | localeDate }} - {{ item.validUntilDateTime | localeDate }}
        </div>
      </div>
      <div class="flex-row form__control">
        <label translate>Acquired</label>
        <div class="form__input">{{ item.purchaseDateTime | localeDate }}</div>
      </div>
    </div>
  </div>
</kpd-collapse-panel>
